import {isPlaneteer} from '@apps-common/auth-utils';

// A canonical list of individual lab keys.
const SAR_DATA = 'sarData';
const SATELLITE_ID_FILTER = 'satelliteIdFilter';
const NEW_API_DIALOG = 'newApiDialog';
const WEBP_MOSAIC_TILES = 'webPMosaicTiles';
const SNAPSHOT = 'snapshot';
const FOLDERS_ITEM_ACTIONS = 'foldersItemActions';
const RESULT_SCENE_SHARE_MENU = 'sceneShareMenu';
const ORDERS_SHOW_PARTIAL = 'ordersShowPartial';
const ORDERS_MULTI_SELECT = 'ordersMultiSelect';
const THEME_MODE = 'themeMode';

// Export object of Lab keys
export const LABS_MAP = {
  SAR_DATA,
  SATELLITE_ID_FILTER,
  NEW_API_DIALOG,
  WEBP_MOSAIC_TILES,
  SNAPSHOT,
  FOLDERS_ITEM_ACTIONS,
  RESULT_SCENE_SHARE_MENU,
  ORDERS_SHOW_PARTIAL,
  ORDERS_MULTI_SELECT,
  THEME_MODE,
};

/**
 * Configs for labs
 * id - unique id for the lab
 * name: display name
 * description
 * available - will be used to filter labs if not defined then it is available to all
 * private - adds Planeteer Only tag
 * @param {} user
 */
const getLabs = user => {
  const userIsPlaneteer = isPlaneteer(user.claims.email);

  return [
    {
      id: LABS_MAP.THEME_MODE,
      name: 'Theme Mode',
      description: `Allows user to choose between light/dark mode or use system settings`,
      available: userIsPlaneteer,
      private: true,
    },
  ];
};

export const LABS_DEFAULT = {};

/**
 * Get the filtered list of labs for the user
 * @param {} user
 */
export const getUserLabs = user => {
  const labs = getLabs(user).filter(lab =>
    lab.available === undefined ? true : lab.available
  );

  return labs;
};

export const getUserLabById = (user, id) =>
  getUserLabs(user).filter(lab => lab.id === id)[0];

/**
 * Just return the keys - mainly used in app.js
 * @param {} user
 */
export const getUserLabKeys = user => {
  return getUserLabs(user).map(lab => lab.id);
};
